import { Host, h } from '@stencil/core';
export class AibaAccordionMap {
  constructor() {
    this.styles = undefined;
    this.multipleOpen = false;
    this.classes = undefined;
    this.identifier = undefined;
    this.items = undefined;
    this.defaultOpen = false;
    this.enableKeyPress = false;
    this.toggleOnMouseHover = false;
    this.openIndexes = [];
    this.handlers = undefined;
  }
  toggleItem(index) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    console.log(event);
    const identifierValue = this.identifier ? `#${this.identifier}-${index}` : `#accordion-item-${index}`;
    if (!this.multipleOpen) {
      if (index === parseInt((_a = this.openIndexes[0]) === null || _a === void 0 ? void 0 : _a.split('-')[1])) {
        this.openIndexes = [];
        const accs = (_b = this.parentRef) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.accordion-item');
        if ((_c = this.parentRef) === null || _c === void 0 ? void 0 : _c.querySelector(identifierValue)) {
          accs.forEach(acc => {
            acc.classList.remove('active');
            acc.classList.remove('initial-load');
          });
          ((_d = this.parentRef) === null || _d === void 0 ? void 0 : _d.querySelector(identifierValue).querySelector('.accordion-content')).style.display = 'none';
          this.parentRef.querySelector(identifierValue).querySelector('aiba-icon').style.transform = 'none';
        }
      }
      else {
        this.openIndexes = [`accordion-${index}`];
        const accs = (_e = this.parentRef) === null || _e === void 0 ? void 0 : _e.querySelectorAll('.accordion-item');
        if ((_f = this.parentRef) === null || _f === void 0 ? void 0 : _f.querySelector(identifierValue)) {
          accs.forEach(acc => {
            acc.classList.remove('active');
            acc.classList.remove('initial-load');
            acc.querySelector('.accordion-content').style.display = 'none';
            acc.querySelector('aiba-icon').style.transform = 'none';
          });
          ((_g = this.parentRef) === null || _g === void 0 ? void 0 : _g.querySelector(identifierValue)).classList.add('active');
          ((_h = this.parentRef) === null || _h === void 0 ? void 0 : _h.querySelector(identifierValue).querySelector('.accordion-content')).style.display = 'block';
          this.parentRef.querySelector(identifierValue).querySelector('aiba-icon').style.transform = 'rotate(180deg)';
        }
      }
    }
    else {
      if (index === parseInt((_j = this.openIndexes[0]) === null || _j === void 0 ? void 0 : _j.split('-')[1])) {
        this.openIndexes = [];
        if ((_k = this.parentRef) === null || _k === void 0 ? void 0 : _k.querySelector(identifierValue)) {
          ((_l = this.parentRef) === null || _l === void 0 ? void 0 : _l.querySelector(identifierValue).querySelector('.accordion-content')).style.display = 'none';
          this.parentRef.querySelector(identifierValue).querySelector('aiba-icon').style.transform = 'none';
        }
      }
      else {
        this.openIndexes = [`accordion-${index}`];
        ((_m = this.parentRef) === null || _m === void 0 ? void 0 : _m.querySelector(identifierValue).querySelector('.accordion-content')).style.display = 'block';
        this.parentRef.querySelector(identifierValue).querySelector('aiba-icon').style.transform = 'rotate(180deg)';
      }
    }
    ((_o = this === null || this === void 0 ? void 0 : this.handlers) === null || _o === void 0 ? void 0 : _o.handleAccordionToggle) && this.handlers.handleAccordionToggle(index);
  }
  componentDidLoad() {
    var _a;
    if (this.toggleOnMouseHover) {
      const accs = (_a = this.parentRef) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.accordion-item');
      accs.forEach((acc, i) => {
        acc.addEventListener('mouseover', () => this.toggleItem(i));
        acc.addEventListener('mouseout', () => this.toggleItem(i));
      });
    }
  }
  render() {
    var _a;
    return (h(Host, { class: this.classes ? this.classes : '' }, this.styles && h("style", null, this.styles), h("div", { class: `accordions-container ${this.defaultOpen ? ' default-open' : ' '}`, ref: el => (this.parentRef = el) }, (_a = this.items) === null || _a === void 0 ? void 0 : _a.map((item, index) => (h("div", { class: `accordion-item initial-load ${this.classes ? this.classes : ''} ${(item === null || item === void 0 ? void 0 : item.identifier) ? item === null || item === void 0 ? void 0 : item.identifier : ''}`, id: this.identifier ? `${this.identifier}-${index}` : `accordion-item-${index}` }, h("div", { class: `accordion-header`, onClick: () => this.toggleItem(index), tabIndex: 0, role: "button", onKeyPress: (event) => {
        if (event.key === 'Enter' && this.enableKeyPress) {
          this.toggleItem(index);
        }
      } }, h("span", { class: "accordion-header__title" }, (item === null || item === void 0 ? void 0 : item.title) && item.title), (item === null || item === void 0 ? void 0 : item.subTitleBefore) && h("span", { class: "accordion-header__subTitle" }, item === null || item === void 0 ? void 0 : item.subTitleBefore), (item === null || item === void 0 ? void 0 : item.iconUrl) && h("aiba-icon", Object.assign({}, item === null || item === void 0 ? void 0 : item.iconData, { url: item === null || item === void 0 ? void 0 : item.iconUrl, altText: (item === null || item === void 0 ? void 0 : item.altText) ? item === null || item === void 0 ? void 0 : item.altText : 'arrow image' })), (item === null || item === void 0 ? void 0 : item.subTitle) && h("span", { class: "accordion-header__subTitle" }, item === null || item === void 0 ? void 0 : item.subTitle)), h("div", { class: "accordion-content" }, item.content)))))));
  }
  static get is() { return "aiba-accordion-map"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-accordion-map.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-accordion-map.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "multipleOpen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "multiple-open",
        "reflect": false,
        "defaultValue": "false"
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "identifier": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "identifier",
        "reflect": false
      },
      "items": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "items",
        "reflect": false
      },
      "defaultOpen": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "default-open",
        "reflect": false,
        "defaultValue": "false"
      },
      "enableKeyPress": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-key-press",
        "reflect": false,
        "defaultValue": "false"
      },
      "toggleOnMouseHover": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "toggle-on-mouse-hover",
        "reflect": false,
        "defaultValue": "false"
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "openIndexes": {}
    };
  }
}
//# sourceMappingURL=aiba-accordion-map.js.map
